import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("ux-accordion", () => {
    it("should match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-accordion>
            <span slot="title">Title</span><p>Content</p>
        </ux-accordion>`);
        const el = await page.find("ux-accordion");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should open and close on keyboard enter", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-accordion>
            <span slot="title">Title</span><p>Content</p>
        </ux-accordion>`);
        await page.waitForChanges();
        const titleContanier = await page.find(".ux-accordion__button.ux-accordion__title-container");
        const accordion = await page.find(".ux-accordion.hydrated");
        await page.waitForChanges();
        expect(accordion).not.toHaveAttribute("is-expanded");
        await titleContanier.focus();
        await titleContanier.press("Enter");
        await page.waitForChanges();
        expect(accordion).toHaveAttribute("is-expanded");
        await titleContanier.click();
        await page.waitForChanges();
        expect(accordion).not.toHaveAttribute("is-expanded");
    });

    it("should open and close on click", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-accordion>
            <span slot="title">Title</span><p>Content</p>
        </ux-accordion>`);
        await page.waitForChanges();
        const titleContanier = await page.find(".ux-accordion__button.ux-accordion__title-container");
        const accordion = await page.find(".ux-accordion.hydrated");
        await page.waitForChanges();
        expect(accordion).not.toHaveAttribute("is-expanded");
        await titleContanier.click();
        await page.waitForChanges();
        expect(accordion).toHaveAttribute("is-expanded");
        await titleContanier.click();
        await page.waitForChanges();
        expect(accordion).not.toHaveAttribute("is-expanded");
    });

    it("should have theme class", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-accordion class="ux-accordion--grey-shadow"></ux-accordion>`);
        const el = await page.find("ux-accordion");
        expect(el).toHaveClass("ux-accordion--grey-shadow");
    });

    it("should render valid html", async () => {
        await testValidHtml(`<ux-accordion>
            <span slot="title">Title</span><p>Content</p>
        </ux-accordion>`);
    });

    it("should update contentContainer maxHeight when removing element from default slot", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-accordion is-expanded>
            <div slot="title">
                Accordion title element
            </div>
            <ul class="ux-list">
                <li>List item 1</li>
                <li>List item 2</li>
                <li>List item 3</li>
            </ul>
        </ux-accordion>`);
        await page.waitForChanges();
        const accordion = await page.find(".ux-accordion.hydrated");
        let contentContainer = await accordion.find(".ux-accordion__content-container");
        let computedStyles = await contentContainer.getComputedStyle("style");
        const initialMaxHeight = computedStyles.getPropertyValue("max-height");
        await page.evaluate(() => {
            const elementToRemove = document.querySelector("ux-accordion .ux-list");
            if (elementToRemove) {
                elementToRemove.remove();
            }
        });
        await page.waitForChanges();
        contentContainer = await accordion.find(".ux-accordion__content-container");
        computedStyles = await contentContainer.getComputedStyle("style");
        const updatedMaxHeight = computedStyles.getPropertyValue("max-height");
        expect(updatedMaxHeight).not.toBe(initialMaxHeight);
    });
});
